import { SafeResourceUrl } from "@angular/platform-browser";

export interface Theme {
  name: string;
  properties: any;
  tenant?:string;
  logo?:Base64Image;
  banner?:Base64Image;
}

export interface Base64Image {
  name:string;
  data:string;
  format:string;
}

export interface Logo{
  name:string;
  data:SafeResourceUrl;
}

export interface Banner{
  name:string;
  data:SafeResourceUrl;
}

export const light: Theme = {
  name: "light",
  properties: {
    "--color-header-background": "#FFFFFF",
    "--color-header-text": "#000000",
    "--color-body-background": "#F6F6F6",
    "--color-button-text": "#4F4F4F",
    "--color-button-border": "#007A9D",
    "--color-button-background": "#FFFFFF",
    "--color-primary": "#007A9D",
    "--color-secondary": "#007A9D50",
    "--color-card-text": "#000000",
    "--color-card-background": "#FFFFFF",
    "--color-interaction-text": "#007A9D",
    "--color-error": "#B00020",
    "--color-card-border": "#f4faff",
    darker: "#000000",
    ligthest: "#CCE4EB",
  },
};

export const dark: Theme = {
  name: "dark",
  properties: {
    "--color-header-background": "#000000",
    "--color-header-text": "#FFFFFF",
    "--color-body-background": "#262626",
    "--color-button-text": "#0DCAF0",
    "--color-button-border": "#0DCAF0",
    "--color-button-background": "#000000",
    "--color-primary": "#0DCAF0",
    "--color-secondary": "#ADB5BD",
    "--color-card-text": "#FFFFFF",
    "--color-card-background": "#000000",
    "--color-interaction-text": "#0DCAF0",
    "--color-error": "#CF6679",
    "--color-card-border": "#000000",
    darker: "#000000",
    ligthest: "#CCE4EB",
  },
};

export const grey: Theme = {
  name: "grey",
  properties: {
    "--color-header-background": "#6200EE",
    "--color-header-text": "#FFFFFF",
    "--color-body-background": "#FFFFFF",
    "--color-button-text": "#000000",
    "--color-button-border": "#03DAC6",
    "--color-button-background": "#03DAC6",
    "--color-primary": "#6200EE",
    "--color-card-text": "#000000",
    "--color-card-background": "#FFFFFF",
    "--color-secondary": "#4f00bf",
    "--color-error-background": "#B00020",
    "--color-error-text": "#FFFFFF",
    "--color-card-border": "#f4faff",
    darker: "#000000",
    ligthest: "#CCE4EB",
  },
};
export const ikea: Theme = {
  name: "ikea",
  properties: {
    "--color-header-background": "#FFFFFF",
    "--color-header-text": "#000000",
    "--color-body-background": "#F6F6F6",
    "--color-button-text": "#FFFFFF",
    "--color-button-border": "#0058A2",
    "--color-button-background": "#0058A2",
    "--color-primary": "#007A9D",
    "--color-secondary": "#0058A2",
    "--color-card-text": "#000000",
    "--color-card-background": "#FFFFFF",
    "--color-interaction-text": "#007A9D",
    "--color-error": "#B00020",
    "--color-card-border": "#f4faff",
    darker: "#000000",
    ligthest: "#CCE4EB",
  },
};

export const sony: Theme = {
  name: "sony",
  properties: {
    "--color-header-background": "#000000",
    "--color-header-text": "#FFFFFF",
    "--color-body-background": "#f1f5f9",
    "--color-button-text": "#FFFFFF",
    "--color-button-border": "#007A9D",
    "--color-button-background": "#5865f5",
    "--color-primary": "#007A9D",
    "--color-secondary": "#007A9D50",
    "--color-card-text": "#000000",
    "--color-card-background": "#FFFFFF",
    "--color-interaction-text": "#007A9D",
    "--color-error": "#B00020",
    "--color-card-border": "#f4faff",
    darker: "#000000",
    ligthest: "#CCE4EB",
  },
};

export const schneider: Theme = {
  name: "schneider",
  properties: {
    "--color-header-background": "#FFFFFF",
    "--color-header-text": "#333333",
    "--color-body-background": "#F6F6F6",
    "--color-button-text": "#FFFFFF",
    "--color-button-border": "#42B4E6",
    "--color-button-background": "#42B4E6",
    "--color-primary": "#3DCD58",
    "--color-secondary": "#007A9D50",
    "--color-card-text": "#333333",
    "--color-card-background": "#FFFFFF",
    "--color-interaction-text": "#42B4E6",
    "--color-error": "#B10043",
    "--color-card-border": "#E7E6E6",
    darker: "#000000",
    ligthest: "#CCE4EB",
  },
};

export const defaultTheme: Theme = {
  name: "default",
  properties: {
    "--color-header-background": "#FFFFFF",
    "--color-header-text": "#000000",
    "--color-body-background": "#F6F6F6",
    "--color-button-text": "#4F4F4F",
    "--color-button-border": "#007A9D",
    "--color-button-background": "#FFFFFF",
    "--color-primary": "#007A9D",
    "--color-card-text": "#000000",
    "--color-card-background": "#FFFFFF",
    "--color-secondary": "#A6A6A6",
    "--color-card-border": "#f4faff",
    darker: "#000000",
    ligthest: "#CCE4EB",
  },
};

export const kuehnenagel: Theme = {
  name: "kuehnenagel",
  properties: {
    "--color-header-background": "#FFFFFF",
    "--color-header-text": "#003369",
    "--color-body-background": "#F6F6F6",
    "--color-button-text": "#FFFFFF",
    "--color-button-border": "#003369",
    "--color-button-background": "#003369",
    "--color-primary": "#007A9D",
    "--color-secondary": "#003369",
    "--color-card-text": "#000000",
    "--color-card-background": "#FFFFFF",
    "--color-interaction-text": "#007A9D",
    "--color-error": "#B00020",
    "--color-card-border": "#f4faff",
    darker: "#000000",
    ligthest: "#CCE4EB",
  },
};

export const muji: Theme = {
  name: "muji",
  properties: {
    "--color-header-background": "#FFFFFF",
    "--color-header-text": "#000000",
    "--color-body-background": "#F6F6F6",
    "--color-button-text": "#4F4F4F",
    "--color-button-border": "#007A9D",
    "--color-button-background": "#FFFFFF",
    "--color-primary": "#007A9D",
    "--color-secondary": "#007A9D66",
    "--color-card-text": "#000000",
    "--color-card-background": "#FFFFFF",
    "--color-interaction-text": "#007A9D",
    "--color-error": "#B00020",
    "--color-card-border": "#f4faff",
    darker: "#000000",
    ligthest: "#CCE4EB",
  },
};
